"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPendingPreauthsSerialization = void 0;
const PaymentTerminalControlPaymentWithPayloadSerialization_1 = require("./PaymentTerminalControlPaymentWithPayloadSerialization");
const PaymentTransactionSerialization_1 = require("./PaymentTransactionSerialization");
class PaymentTerminalControlPendingPreauthsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.pending_preauths = entity.pending_preauths?.map((field) => field
            ? JSON.parse(PaymentTerminalControlPaymentWithPayloadSerialization_1.PaymentTerminalControlPaymentWithPayloadSerialization.serialize(field))
            : undefined);
        copy.failed_session_persisted_preauths =
            entity.failed_session_persisted_preauths?.map((field) => field
                ? JSON.parse(PaymentTransactionSerialization_1.PaymentTransactionSerialization.serialize(field))
                : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.pending_preauths = entity.pending_preauths?.map((field) => field
            ? PaymentTerminalControlPaymentWithPayloadSerialization_1.PaymentTerminalControlPaymentWithPayloadSerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.failed_session_persisted_preauths =
            entity.failed_session_persisted_preauths?.map((field) => field
                ? PaymentTransactionSerialization_1.PaymentTransactionSerialization.deserialize(JSON.stringify(field))
                : undefined);
        return copy;
    }
}
exports.PaymentTerminalControlPendingPreauthsSerialization = PaymentTerminalControlPendingPreauthsSerialization;
